import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BtnType } from '../../type/btnType.type';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'app-square-icon-btn',
  templateUrl: './square-icon-btn.component.html',
  styleUrls: ['./square-icon-btn.component.scss'],
})
export class SquareIconBtnComponent {
  @Input('color') color: ThemePalette;
  @Input('icon') icon: string = 'favorite';
  @Input('type') type: BtnType = 'button';
  @Input('disabled') disabled: boolean = false;
}
